import script from "./DIL_Switches.vue?vue&type=script&lang=ts&setup=true"
export * from "./DIL_Switches.vue?vue&type=script&lang=ts&setup=true"

import "./DIL_Switches.vue?vue&type=style&index=0&id=0e1be710&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e1be710"]])

export default __exports__